import React from 'react';
import { DivInputContainer, Input, TagError } from './Styles';

interface InputBirthDate {
  value: string;
  error: boolean;
  setBirthDate: React.Dispatch<React.SetStateAction<string>>;
}

export default function InputBirthDate({
  value,
  error,
  setBirthDate,
}: InputBirthDate) {
  return (
    <>
      <DivInputContainer error={error}>
        <Input
          mask='99/99/9999'
          value={value}
          placeholder='__/__/____'
          onChange={(e) => {
            setBirthDate(e.target.value);
          }}
        />
        {error && <TagError>Data de nascimento incorreta</TagError>}
      </DivInputContainer>
    </>
  );
}
